<template>
  <div id="app">
    <page-header />
    <router-view class="view" />
    <page-footer />
    <img src="../src/assets/bricks.png" class="bricks bricksTopRight" alt="">
    <img src="../src/assets/bricks.png" class="bricks bricksLeftMiddle" alt="">
    <img src="../src/assets/bricks.png" class="bricks bricksRightMiddle" alt="">
    <img src="../src/assets/bricks.png" class="bricks bricksBottomCentre" alt="">
  </div>
</template>
<script>
import PageHeader from './components/Header.vue';
import PageFooter from './components/Footer.vue';

export default {
  components: {
    PageHeader,
    PageFooter,
  },
};
</script>
<style lang="scss">
body {
  background-color: $kfc-light;
  margin: 0;
  padding: 0;
  position: relative;
  min-height: 100vh;
}

* {
  box-sizing: border-box;
}

button {
  border: 0;
  background-color: transparent;
  padding: 0;
  -webkit-appearance: none;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.view {
  flex-grow: 1;
}

.bricks {
  position: absolute;
  max-width: 200px;
  z-index: -1;
  opacity: 0.4;
  @include tablet {
    max-width: 100%;
  }

  &TopRight {
    right: 0;
    top: 200px;
    @include tablet {
      top: 0;
    }
  }

  &LeftMiddle {
    left: 0;
    top: 300px;
    display: none;
    @include tablet {
      display: block;
    }
  }

  &RightMiddle {
    right: 0;
    bottom: 300px;
  }

  &BottomCentre {
    bottom: 5px;
    left: -40%;
    right: 0;
    margin: 0 auto;
    display: none;
    @include tablet {
      display: block;
    }
  }

}
</style>
